import { useState } from "react";

import TabHeader from "../../tab/TabHeader";
import DocumentControls from "./controls/DocumentControls";
import ProcoDocsDetails from "./ProcoDocsDetails";

export default function ProcoDocsTab({ inWorkQ }) {
    
    const [uploaded, setUploaded] = useState([])  

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Proco Documents</h2>
            </div>
            <DocumentControls setUploaded={(data) => setUploaded(data)}/>
            
        </TabHeader>

        <ProcoDocsDetails uploadedFile={uploaded} inWorkQ={inWorkQ}/>
    </>
}
